import React, { useState } from 'react'
import Link from 'next/link'
import { Trans, useTranslation } from 'next-i18next'
import {
  Bleed,
  Stack,
  Text,
  useResponsiveValue
} from '@machobear/design-system'
import { useFormikContext } from 'formik'

import { PasswordRequirements } from '@/features/Auth/components'
import { PasswordInput } from '@/components/form'
import { ParagraphSmall } from '@/components/text'

import { MyFormValues } from '.'

const ApplyFlowStepThree = ({
  requirements,
  checkRequirements
}: {
  requirements: { one: boolean; two: boolean; three: boolean; four: boolean }
  checkRequirements: (value: string) => void
}) => {
  const { t } = useTranslation()
  const [passwordFocused, setPasswordFocused] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const { setFieldValue } = useFormikContext<MyFormValues>()
  const isMobile = useResponsiveValue()({ mobile: true, tablet: false })

  return (
    <Bleed top={isMobile ? 'medium' : 'xxlarge'}>
      <Stack space="xlarge">
        <Stack space="medium">
          <Text size="small" weight="strong" tone="secondary">
            {t('r.auth.create.step_three.label', 'Step 3 of 3')}
          </Text>

          <Text size="xlarge" weight="strong">
            {t(
              'r.auth.create.password_title.text',
              "Lastly, let's create a password"
            )}
          </Text>
          <Text size="small" weight="strong" tone="secondary">
            {t(
              'r.auth.create.password_description.text',
              'So you can save and manage your application.'
            )}
          </Text>
        </Stack>
        <Stack space="xsmall">
          <PasswordInput
            name="password"
            autoComplete="section-register-renter new-password"
            placeholder={t(
              'b.auth.create.enter_password.label',
              'Enter password'
            )}
            autoFocus
            required
            onChange={e => {
              setFieldValue('password', e.target.value)
              checkRequirements(e.target.value)
            }}
            visible={showPassword}
            setVisible={setShowPassword}
            onFocus={() => setPasswordFocused(true)}
            onBlur={() => setPasswordFocused(false)}
            hideError={passwordFocused}
          />

          <PasswordRequirements
            requirements={requirements}
            show={passwordFocused}
          />

          <Trans i18nKey="r.auth.view.agree_terms_privacy.text">
            <ParagraphSmall>
              By clicking “Create Application”, I confirm that I have read and
              agreed to liv.rent
              {`'`}s{' '}
              <Link href="/terms" target="_blank">
                Terms & Conditions
              </Link>{' '}
              and{' '}
              <Link href="/privacy" target="_blank">
                Privacy Policy
              </Link>
              .
            </ParagraphSmall>
          </Trans>
        </Stack>
      </Stack>
    </Bleed>
  )
}

export default ApplyFlowStepThree
